<template>
  <div class="pop">
    <div class="cancel-btn" @click="close">
      <img style="width: 40px;"
           src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguOTk2IDQuNzEyODlDMTEuMTEzNCA0LjcxMjg5IDQuNzEyODkgMTEuMTEzMyA0LjcxMjg5IDE4Ljk5NjZDNC43MTI4OSAyNi44Nzk5IDExLjExMzQgMzMuMjgwMyAxOC45OTYgMzMuMjgwM0MyNi44ODEgMzMuMjgwMyAzMy4yNzkzIDI2Ljg3OTkgMzMuMjc5MyAxOC45OTY2QzMzLjI3OTMgMTEuMTEzMyAyNi44ODEgNC43MTI4OSAxOC45OTYgNC43MTI4OVpNMTguOTk2IDYuNjEyODlDMjUuODMxMyA2LjYxMjg5IDMxLjM3OTMgMTIuMTYxOCAzMS4zNzkzIDE4Ljk5NjZDMzEuMzc5MyAyNS44MzEzIDI1LjgzMTMgMzEuMzgwMyAxOC45OTYgMzEuMzgwM0MxMi4xNjA4IDMxLjM4MDMgNi42MTI4OSAyNS44MzEzIDYuNjEyODkgMTguOTk2NkM2LjYxMjg5IDEyLjE2MTggMTIuMTYwOCA2LjYxMjg5IDE4Ljk5NiA2LjYxMjg5WiIgZmlsbD0iI0Y2RDlBQSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuNDUzMiAxMS4yMTA4TDExLjIyNDQgMjUuNDM5N0MxMC44NTM2IDI1LjgxMDUgMTAuODUzMiAyNi40MTIgMTEuMjI0NCAyNi43ODMyQzExLjU5NTUgMjcuMTU0MyAxMi4xOTcxIDI3LjE1NCAxMi41Njc5IDI2Ljc4MzJMMjYuNzk2OCAxMi41NTQzQzI3LjE2NzQgMTIuMTgzNyAyNy4xNjc5IDExLjU4MiAyNi43OTY4IDExLjIxMDhDMjYuNDI1NiAxMC44Mzk3IDI1LjgyMzkgMTAuODQwMiAyNS40NTMyIDExLjIxMDhaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi43ODkyIDI1LjQzNDdMMTIuNTYwMyAxMS4yMDU4QzEyLjE4OTUgMTAuODM1IDExLjU4OCAxMC44MzQ3IDExLjIxNjggMTEuMjA1OEMxMC44NDU3IDExLjU3NyAxMC44NDYgMTIuMTc4NSAxMS4yMTY4IDEyLjU0OTNMMjUuNDQ1NyAyNi43NzgyQzI1LjgxNjMgMjcuMTQ4OCAyNi40MTggMjcuMTQ5MyAyNi43ODkyIDI2Ljc3ODJDMjcuMTYwMyAyNi40MDcxIDI3LjE1OTggMjUuODA1MyAyNi43ODkyIDI1LjQzNDdaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPC9zdmc+DQo=">
    </div>
    <div>
      <div class="rule-item" v-for="(item, index) in ruleList" :key="index">
        <div class="rule-number">
          <span>{{ index + 1 }}</span>
        </div>
        <div class="rule-value">
            <span>{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'withdrawalRulePop',
  props: ['handleClose'],
  data () {
    return {
      ruleList: this.$t('lang.account.withdrawalRuleList')
    }
  },
  mounted () {
  },
  methods: {
    close () {
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
.pop{
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  padding: 40px 20px;
  z-index: 5;
  background-color: rgba(0,0,0,.9);

  .cancel-btn{
    position: absolute;
    top: 20px;
    right: 20px;
    width: 38px;
    height: 38px;
  }

  .rule-item {
    display: flex;
    color: #F6D9AA;
    margin: 18px 0;
    .rule-number {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      margin-left: 5px;
      border-radius: 50%;
      border: 1px solid #F6D9AA;
      text-align: center;
      line-height: 30px;
      font-size: 20px;
    }
    .rule-value {
      width: calc(100% - 45px);
      margin-left: 10px;
      text-align: left;
      padding-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawalRules/index.vue